import { createSelector } from "@reduxjs/toolkit"

export const modalSelector = (name) =>
  createSelector(
    (state) => state.modals,
    (modals) => modals[name] || {}
  )

export const confirmModalSelector = modalSelector("confirmModal")
